<template>
  <ExtForm
    :formData="formData"
    :submitProxy="submitProxy"
    submitBtnText="Отправить анкету"
    submitBtnClasses="btn btn-success btn-block"
    @submitSuccess = "$emit('submitSuccess')"
    :showNotyfications="false"
    :extraData="{ type: 'advanced' }"
  >
    <b-form-fieldset
      label="ФИО*"
      :class="{'is-invalid': errors.has('fio') }"
      :feedback = "errors.first('fio')"
      horizontal
    >
      <input class="form-control" v-model.trim="formData.fio" v-validate="'required'" name="fio"/>
    </b-form-fieldset>
    <b-form-fieldset
      label="Дата рождения*"
      :class="{'is-invalid': errors.has('birthdate') }"
      :feedback = "errors.first('birthdate')"
      horizontal
    >
      <InlineDatepicker v-model="formData.birthdate" v-validate="'required|date'" name="birthdate"/>
    </b-form-fieldset>
    <b-form-fieldset
      label="Место рождения*"
      :class="{'is-invalid': errors.has('birthplace') }"
      :feedback = "errors.first('birthplace')"
      horizontal
    >
      <input class="form-control" v-model.trim.lazy="formData.birthplace" v-validate="'required'" name="birthplace"/>
    </b-form-fieldset>
    <b-form-fieldset
      label="Email*"
      :class="{'is-invalid': errors.has('email') }"
      :feedback = "errors.first('email')"
      horizontal
    >
      <input class="form-control" v-model.trim.lazy="formData.email" v-validate="'required|email'" name="email"/>
    </b-form-fieldset>
    <b-form-fieldset
      label="Контактный телефон*"
      :class="{'is-invalid': errors.has('tel') }"
      :feedback = "errors.first('tel')"
      horizontal
    >
      <input class="form-control"
        v-model.trim="formData.tel"
        v-validate="'required'"
        name="tel"
        v-mask="'+7 (###) ###-##-##'"
      />
    </b-form-fieldset>
    <b-form-fieldset
      label="Образование*"
      :class="{'is-invalid': errors.has('education') }"
      :feedback = "errors.first('education')"
      horizontal
    >
      <textarea class="form-control" v-model.trim="formData.education" rows="4" v-validate="'required'" name="education"/>
      <small class="text-muted">Название  ВУЗа, факультета, специальности</small>
    </b-form-fieldset>
    <b-form-fieldset
      label="Год  окончания ВУЗа*"
      :class="{'is-invalid': errors.has('graduationYear') }"
      :feedback = "errors.first('graduationYear')"
      horizontal
    >
      <input class="form-control" v-mask="'####'" v-model.trim="formData.graduationYear" v-validate="'required|numeric'" name="graduationYear"/>
    </b-form-fieldset>
    <b-form-fieldset
      label="Образование  по  профессии «Экскурсовод»*"
      :class="{'is-invalid': errors.has('guideEducation') }"
      :feedback = "errors.first('guideEducation')"
      horizontal
    >
      <textarea class="form-control" v-model.trim="formData.guideEducation" rows="4" v-validate="'required'" name="guideEducation"/>
      <small class="text-muted">Указать название курсов, ВУЗа, год окончания</small>
    </b-form-fieldset>
    <b-form-fieldset
      label="Место  работы и должность*"
      :class="{'is-invalid': errors.has('workAndPosition') }"
      :feedback = "errors.first('workAndPosition')"
      horizontal
    >
      <input class="form-control" v-model.trim="formData.workAndPosition" v-validate="'required'" name="workAndPosition"/>
    </b-form-fieldset>
    <b-form-fieldset
      label="Стаж  работы экскурсоводом*"
      :class="{'is-invalid': errors.has('guideWorkExprience') }"
      :feedback = "errors.first('guideWorkExprience')"
      horizontal
    >
      <textarea class="form-control" v-model.trim="formData.guideWorkExprience"  v-validate="'required'" rows="4" name="guideWorkExprience"/>
      <small class="text-muted">В каких  фирмах работали, когда?</small>
    </b-form-fieldset>
    <b-form-fieldset
      label="Экскурсии, которые  Вы водите*"
      :class="{'is-invalid': errors.has('ownExcursions') }"
      :feedback = "errors.first('ownExcursions')"
      horizontal
    >
      <textarea class="form-control" v-model.trim="formData.ownExcursions" v-validate="'required'" name="ownExcursions" rows="4"/>
    </b-form-fieldset>
    <b-form-fieldset
      label="Дата выдачи аккредитации ГТИЦ*"
      :class="{'is-invalid': errors.has('gticDateFrom') }"
      :feedback = "errors.first('gticDateFrom')"
      horizontal
    >
      <datepicker
        v-model="formData.gticDateFrom"
        v-validate="'required'"
        name="gticDateFrom"
        placeholder="выберите дату"
      />
    </b-form-fieldset>
    <b-form-fieldset
      label="Срок действия аккредитации ГТИЦ*"
      :class="{'is-invalid': errors.has('gticDateTo') }"
      :feedback = "errors.first('gticDateTo')"
      horizontal
    >
      <datepicker
        v-model="formData.gticDateTo"
        v-validate="'required'"
        name="gticDateTo"
        placeholder="выберите дату"
      />
    </b-form-fieldset>
    <b-form-fieldset label="Лицензия ППК" horizontal>
      <input class="form-control" v-model.trim="formData.ppk" name="ppk" />
    </b-form-fieldset>
    <b-form-fieldset label="Срок действия лицензии ППК" horizontal>
      <datepicker v-model="formData.ppkDateTo" name="ppkDateTo" placeholder="выберите дату"/>
    </b-form-fieldset>
    <b-form-fieldset label="Из  каких  источников узнали о наших курсах?" horizontal>
      <input class="form-control" v-model.trim="formData.sourceFrom" name="sourceFrom" />
    </b-form-fieldset>
    <b-form-fieldset label="Какие темы по истории города для Вас наиболее интересны?" horizontal>
      <input class="form-control" v-model.trim="formData.interestingTopics" />
    </b-form-fieldset>
  </ExtForm>
</template>

<script>
import ExtForm from '@/components/ExtForm'
import Datepicker from '@/components/Datepicker'
import InlineDatepicker from '@/components/InlineDatepicker'

export default {
  data () {
    return {
      formData: {
        birthdate: '',
        birthplace: '',
        fio: '',
        email: '',
        tel: '',
        education: '',
        graduationYear: '',
        guideEducation: '',
        workAndPosition: '',
        guideWorkExprience: '',
        ownExcursions: '',
        gticDateFrom: '',
        gticDateTo: '',
        ppk: '',
        ppkDateTo: '',
        sourceFrom: '',
        interestingTopics: ''
      },
      submitProxy: {
        url: 'mail.php',
        method: 'post'
      }
    }
  },
  components: {
    ExtForm,
    Datepicker,
    InlineDatepicker
  }
}
</script>



// WEBPACK FOOTER //
// AdvancedLevelQuestionnaire.vue?569aeb53